import Header from "@/components/Header"
import Footer from "@/components/Footer"

const useSections = [
  {
    id: "Definitions",
    title: "Definitions",
    body: (
      <p className="leading-[28px]">
        <p>1.1 “Data” means any financial information, market quotations, analytics, metadata, or other content delivered through the API and or SFTP.</p>
        <p>1.2 “Internal Use” means use by you solely for your own internal, non‑commercial purposes, excluding any resale, republication, sublicensing, public display, or other distribution to third parties.</p>
        <p>1.3 “Services” means the API, SFTP, related documentation, and any support or maintenance services we provide.</p>
      </p>
    ),
  },
  {
    id: " License & Permitted Use",
    title: " License & Permitted Use",
    body: (
      <>
        <p>2.1 Grant. Subject to full compliance with this Agreement, IData grants you a limited, revocable, non‑exclusive, non‑transferable, and non‑sublicensable license to the data access solely for Internal Use.</p>
        <p>2.2 No Redistribution. YOU MAY NOT COPY, STORE, DOWNLOAD, EXPORT, TRANSFER, DISPLAY, POST, PUBLISH, SELL, LEASE, LICENSE, SUBLICENSE, OR OTHERWISE REDISTRIBUTE THE DATA OR ANY DERIVATIVE THEREOF TO ANY THIRD PARTY IN ANY FORM.</p>
        <p>2.3 Reservation of Rights. Except for the limited license expressly granted above, IData and its licensors retain all right, title, and interest in the data provided, and all related intellectual‑property rights.</p>
      </>
    ),
  },
  {
    id: "Prohibited Conduct",
    title: "Prohibited Conduct",
    body: (
      <p>You shall not, directly or indirectly: 1. Use the API or Data for any purpose other than Internal Use; 2. Reverse engineer, decompile, disassemble, or attempt to derive source code from the API; 3. Circumvent or disable any security or usage‑control features; 4. Use the API to create, market, or distribute any product or service that is competitive with or substitutes of IData; 5. Use the API in any unlawful manner or in violation of applicable laws, regulations, or the rights of any third party.</p>
    ),
  },
  {
    id: "Use of Information and Feedback",
    title: "Use of Information and Feedback",
    body: (
      <>
        <p>Customer acknowledges and agrees that IData shall have a perpetual, irrevocable, worldwide right to access, use, and evaluate all information submitted, transmitted, or otherwise made available to IData in connection with the Services (“Use Information”) for any lawful purpose, including internal analysis, service improvement, and product development, without obligation to account to or compensate Customer. To the extent any Use Information includes Personal Data, IData’s collection, use, retention, and disclosure of such Personal Data shall be governed by the IData Privacy Policy, as amended from time to time.</p>
        <p>Customer, its Affiliates, and its Authorized Users may, but are not obligated to, provide suggestions, comments, or other feedback relating to IData’s software, services, or business operations (collectively, “Feedback”). By providing such Feedback, Customer, on behalf of itself, its Affiliates, and its Authorized Users, grants to IData a non-exclusive, royalty-free, fully paid, perpetual, irrevocable, transferable, sub-licensable, and worldwide license to use, reproduce, modify, distribute, and otherwise exploit such Feedback for any purpose, including incorporation into IData’s software, Services, or business processes, without restriction or obligation of any kind.</p>
        <p>Customer further acknowledges and agrees that IData may compile, generate, and use data derived from use Information that has been aggregated, de-identified, anonymized, or otherwise rendered not reasonably capable of identifying Customer or any individual (“De-identified Data”) for purposes including, but not limited to, service optimization, platform analytics, product enhancement, marketing, regulatory compliance, and audit requirements. For the avoidance of doubt, all De-identified Data shall be the sole and exclusive property of IData and shall be deemed IData’s Confidential Information.</p>
      </>
    ),
  },
  {
    id: "Availability & Maintenance",
    title: "Availability & Maintenance",
    body: (
      <>
        <p>5.1 Downtime. The Services may be unavailable or degraded from time to time, whether for planned maintenance, emergency maintenance, force‑majeure events, or other reasons. IData does not guarantee uninterrupted or error‑free operation and shall have no liability for any unavailability, delay, or failure of the Services.</p>
        <p>5.2 Modifications. We may modify, suspend, remove certain data or discontinue the API (in whole or part) at any time without liability. </p>
      </>
    ),
  },
  {
    id: "Data Accuracy & Investment Disclaimer",
    title: "Data Accuracy & Investment Disclaimer",
    body: (
      <>
        <p>THE DATA IS PROVIDED “AS IS” AND “AS AVAILABLE.”  Although obtained from sources believed reliable, IData does not warrant, guarantee, or make any representation regarding the accuracy, completeness, timeliness, or reliability of the data.  The data is not investment advice or an offer or solicitation to buy or sell any security.  You are solely responsible for verifying the data before relying on it.</p>
      </>
    ),
  },
  {
    id: "Fees & Payment",
    title: "Fees & Payment",
    body: (
      <>
        <p>You agree to pay all fees specified in the order form. Fees are non‑refundable unless required by law. We may suspend or terminate access for late or unpaid amounts.</p>
      </>
    ),
  },
  {
    id: "Confidentiality",
    title: "Confidentiality",
    body: (
      <>
        <p>Each party (“Receiving Party”) agrees that all non-public, confidential, or proprietary information disclosed by the other party (“Disclosing Party”) in connection with this these terms of use, whether oral, written, electronic, or in any other form, that is designated as confidential or that reasonably should be understood to be confidential given the nature of the information or the circumstances of disclosure (“Confidential Information”), shall be kept strictly confidential and shall not be disclosed to any third party without the prior written consent of the Disclosing Party.</p>
        <p>The Receiving Party shall use the same degree of care to protect the confidentiality of such information as it uses to protect its own confidential information of like kind, but in no event less than a reasonable degree of care. The Receiving Party shall use the Confidential Information solely for the purpose of fulfilling its obligations under this Agreement and shall disclose such information only to its employees, agents, affiliates, contractors, and legal or financial advisors who have a legitimate need to know and who are bound by confidentiality obligations at least as restrictive as those contained herein.</p>
        <p>The obligations under this Section shall not apply to information that (i) was publicly known at the time of disclosure or becomes publicly known through no wrongful act of the Receiving Party; (ii) is lawfully obtained by the Receiving Party from a third party without restriction and without breach of any duty of confidentiality; (iii) is independently developed by the Receiving Party without use of or reference to the Disclosing Party’s Confidential Information; or (iv) is required to be disclosed pursuant to a valid order of a court or governmental agency, provided that the Receiving Party gives prompt notice of such requirement to the Disclosing Party and cooperates in any efforts to seek a protective order or otherwise limit the scope of such disclosure.</p>
        <p>The confidentiality obligations set forth in this Section shall survive the termination or expiration of this Agreement for a period of five (5) years, or for such longer period as may be required under applicable law with respect to trade secrets.</p>
      </>
    ),
  },
  {
    id: "Indemnification",
    title: "Indemnification",
    body: (
      <>
        <p>You agree to defend, indemnify, and hold harmless IData . (“IData”), its affiliates, subsidiaries, licensors, service providers, and each of their respective officers, directors, employees, agents, successors, and assigns (collectively, the “Indemnified Parties”) from and against any and all third-party claims, demands, actions, liabilities, losses, damages, judgments, settlements, costs, and expenses (including, without limitation, reasonable attorneys’ fees and court costs) arising out of or related to:</p>
        <p>(a) your use or misuse of the API, Data, or any Services provided under this Agreement;(b) your breach or violation of any term, condition, representation, warranty, or covenant contained in this Agreement;(c) your violation of any applicable law, regulation, or third-party right, including but not limited to intellectual property, privacy, or data protection rights; or(d) any content or data you provide or transmit through the API,and or the SFTP including claims that such content infringes or misappropriates any intellectual property or other proprietary right of any third party.</p>
        <p>IData reserves the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify the Indemnified Parties, and you agree to cooperate with IData’s defense of such claims. You shall not settle any matter without the prior written consent of IData .</p>
      </>
    ),
  },
  {
    id: "Disclaimer of Warranties",
    title: "Disclaimer of Warranties",
    body: (
      <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, IDATA DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, AND NON‑INFRINGEMENT.  IDATA DOES NOT WARRANT THAT THE SERVICES WILL BE AVAILABLE, ERROR‑FREE, OR SECURE.</p>
    ),
  },
  {
    id: "Limitation of Liability",
    title: "Limitation of Liability",
    body: (
      <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW: - EXCLUSION OF DAMAGES. IDATA SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES, OR FOR LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. - CAP ON LIABILITY. IDATA’S TOTAL AGGREGATE LIABILITY UNDER THIS AGREEMENT SHALL NOT EXCEED THE GREATER OF (A) THE FEES ACTUALLY PAID BY YOU TO IDATA FOR THE SIX (6) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM, OR (B) ONE HUNDRED U.S. DOLLARS (US $100).</p>
    ),
  },
  {
    id: "Term & Termination",
    title: "Term & Termination",
    body: (
      <>
        <p>12.1 Term. This Agreement begins when you first access the API and continues until terminated, either monthly or yearly subscriptions available in the paid version of the product. </p>
        <p>12.2 Termination for Convenience. Either party may terminate this Agreement at any time for any reason upon written notice.</p>
        <p>12.3 Termination for Breach. We may suspend or terminate the Services immediately if you breach this Agreement.</p>
        <p>12.4 Effect of Termination. Upon termination, all licenses immediately cease and you must delete all Data in your possession or control.</p>
      </>
    ),
  },
  {
    id: "Governing Law & Dispute Resolution",
    title: "Governing Law & Dispute Resolution",
    body: (
      <>
        <p>This Agreement is governed by the laws of the State of New York, without regard to conflict‑of‑law principles. Any dispute, claim, or controversy arising out of or relating to this Agreement shall be finally settled by binding arbitration administered in New York New York, in English, EACH PARTY WAIVES ITS RIGHT TO A JURY TRIAL.</p>
      </>
    ),
  },
  {
    id: "Modifications to Agreement",
    title: "Modifications to Agreement",
    body: (
      <>
        <p>We may amend this Agreement by posting a revised version on our website or within the Services. Changes become effective on the date indicated. Your continued use of the Services after the effective date constitutes acceptance.</p>
      </>
    ),
  },
  {
    id: "Disclaimer",
    title: "Disclaimer",
    body: (
      <>
        <p>EXCEPT AS EXPRESSLY PROVIDED FOR HEREIN, THE SERVICES AND ALL INFORMATION ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT ANY WARRANTIES OF ANY KIND, AND IDATA EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. CUSTOMER ACKNOWLEDGES THAT IDATA DOES NOT REPRESENT OR WARRANT THAT THE SERVICES AND THE INFORMATION WILL BE UNINTERRUPTED, TIMELY, SECURE, ACCURATE, OR ERROR-FREE. CUSTOMER ASSUMES ALL RESPONSIBILITY FOR DETERMINING WHETHER THE SERVICES AND THE INFORMATION ARE ACCURATE OR SUFFICIENT FOR CUSTOMER'S PURPOSE. IT IS EXPRESSLY UNDERSTOOD THAT THE SERVICES AND THE INFORMATION ARE NOT INTENDED TO PROVIDE LEGAL, TAX, INVESTMENT, FINANCIAL, OR ACCOUNTING ADVICE, NOR SHOULD THE SERVICES OR THE INFORMATION BE CONSTRUED AS A RECOMMENDATION, OR AN OFFER TO BUY OR SELL, OR THE SOLICITATION OF AN OFFER TO BUY OR SELL ANY SECURITY, FINANCIAL PRODUCT, OR INSTRUMENT OR TO PARTICIPATE IN ANY TRADING STRATEGY.</p>
      </>
    ),
  },
  {
    id: "Miscellaneous",
    title: "Miscellaneous",
    body: (
      <ul>
        <li>Assignment. You may not assign or transfer this Agreement without our prior written consent. Any attempted assignment in violation is null and void. We may assign our rights and obligations without restriction.</li>
        <li>Relationship.  This Agreement does not create any partnership, joint venture, agency, or employment relationship.</li>
        <li>Entire Agreement. This Agreement constitutes the entire agreement between the parties and supersedes all prior or contemporaneous agreements on the subject matter.</li>
        <li>Severability & Waiver. If any provision is held invalid, the remaining provisions will remain in effect. Failure to enforce any provision is not a waiver.</li>
      </ul>
    ),
  },
]

export default function PrivacyPolicyPage() {
  /* smooth scroll helper */
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" })

  return (
    <div className="bg-white text-gray-800" id="top">
      <Header routes={[
        { path: "/privacy-policy", label: "Privacy Policy" },
        { path: "/term-of-use", label: "Term of Use" }]}
        scrollThreshold={440}
      />
      {/* hero */}
      <section className="h-[440px] font-titillium">
        <div className="relative text-white h-full flex items-center bg-[url('@/assets/images/term-banner.png')] bg-cover bg-center">
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-transparent" />
          <div className="relative z-10 container max-w-7xl mx-auto px-4 container-max-w">
            <h1 className="text-5xl font-bold">Term of Use</h1>
          </div>
        </div>
      </section>

      {/* main */}
      <main className="container container-max-w mx-auto py-16">
        {/* table of contents */}
        <ol className="space-y-[30px] mb-[30px]">
          {useSections.map((s, i) => (
            <li key={s.id}>
              <a href={`#${s.id}`} className="underline text-[22px] text-[rgba((22,22,22,0.85)]
              font-bold hover:underline hover:text-[#297FFF]">
                {i + 1}. {s.title}
              </a>
            </li>
          ))}
        </ol>
        <p className="text-[22px] text-[rgba(22,22,22,0.85)] font-bold">iData Tech, Inc. – Terms of Use</p>
        <p className="text-[22px] text-[rgba(22,22,22,0.85)] font-bold">Last Updated: June 22, 2025</p>
        <p className="text-[22px] text-[rgba(22,22,22,0.85)] font-bold mb-[80px]">This API Terms of Use Agreement (“Agreement”) is a legal contract between iData Tech, Inc. (“iData,” “we,” “our,” or “us”) and the individual that registers for, accesses, or uses the IData application‑programming interface (“API”) OR STFP (“Customer,” “you,” or “your”). BY ACCESSING OR USING THE API, YOU AGREE TO BE BOUND BY THIS AGREEMENT. IF YOU DO NOT AGREE, YOU WILL NOT BE GRANTED TO THE API OR SFTP.</p>

        {/* sections */}
        <div className="space-y-16">
          {useSections.map((s, i) => (
            <section key={s.id} id={s.id} className="scroll-mt-24">
              <header className="mb-4">
                <h2 className="text-[40px]">
                  {i + 1}. {s.title}
                </h2>
                <div onClick={scrollToTop} className="text-[22px] text-[#4D4D4D] underline
                cursor-pointer my-[16px] hover:text-[#297FFF]">back to top</div>
              </header>
              <div className="text-[16px] text-[#4d4d4d]">{s.body}</div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  )
}
